import { AnySchema, ValidationError } from 'yup'
import AddressHistoryValidator from '../../../validators/AddressHistoryValidator'
import { AttributionDetails } from '../../ApplicationForm/types'
import { AddressHistoryEntry } from './AddressHistoryContext'

export const validateEntry = (
  entry : AddressHistoryEntry,
  attribution : AttributionDetails,
  validateSituation = false,
  validateAddressDetails = false,
  validateTimeInSituation = false
) : ValidationError[] | boolean => {
  const AddressSituationSchema = AddressHistoryValidator
    .AddressSituationValidator(attribution)
    .getValidator()
  const AddressDetailsSchema = AddressHistoryValidator
    .AddressDetailsValidator()
    .getValidator()
  const AddressLengthOfTimeSchema = AddressHistoryValidator
    .LengthOfTimeValidator()
    .getValidator()

  let schema : AnySchema | undefined
  if (validateSituation) {
    schema = AddressSituationSchema
  }
  if (validateAddressDetails) {
    schema = schema === undefined ? AddressDetailsSchema : schema.concat(AddressDetailsSchema)
  }
  if (validateTimeInSituation) {
    schema = schema === undefined ? AddressLengthOfTimeSchema : schema.concat(AddressLengthOfTimeSchema)
  }

  if (schema === undefined) return false

  try {
    schema.validateSync({
      addressSituation: entry?.addressSituation,
      months: entry?.lengthOfTime?.months,
      years: entry?.lengthOfTime?.years,
      flatNumber: entry?.addressDetails?.flatNumber,
      buildingName: entry?.addressDetails?.buildingName,
      buildingNumber: entry?.addressDetails?.buildingNumber,
      street: entry?.addressDetails?.street,
      town: entry?.addressDetails?.town,
      county: entry?.addressDetails?.county,
      postcode: entry?.addressDetails?.postcode
    }, { abortEarly: false })
    return true
  } catch (e) {
    const validationError = e as ValidationError
    if (!validationError.inner) return false
    return validationError.inner
  }
}

export const createAddressEntryValidator = (attribution : AttributionDetails) => (entry : AddressHistoryEntry) : boolean => {
  const validationErrors = validateEntry(
    entry,
    attribution,
    true,
    true,
    true
  )
  return validationErrors === true
}
